import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { throwNonBlockingError } from '@beef/utils';
import { getBlockAlias } from "../../blocks/utils";

/**
 * @param { ReactNode } children
 * @returns {{ [string]: ReactNode }}
 */
var extractBlocksDict = function extractBlocksDict(children) {
  var blocks = React.Children.toArray(children);
  return blocks.reduce(function (accum, node) {
    return _objectSpread(_objectSpread({}, accum), {}, _defineProperty({}, getBlockAlias(node.type), node));
  }, {});
};

/**
 * Изменяет порядок children'ов в соответствии с порядком alias'ов
 * NOTE: Один alias = один блок
 * (полученных в порядке 'positionOrder')
 *
 * @param { string[] } aliases
 * @param { ReactNode } children
 * @returns { ReactNode[] }
 */
export var getFilteredBlocks = function getFilteredBlocks(aliases, children, exceptionAlias) {
  var blocksDict = extractBlocksDict(children);
  var filtered = [];
  aliases.forEach(function (alias) {
    if (blocksDict[alias]) {
      filtered.push( /*#__PURE__*/React.cloneElement(blocksDict[alias], {
        key: alias
      }));
    } else if (process.env.NODE_ENV === 'development') {
      // Если блок является исключением exceptionAlias не выводить ошибку
      if (alias === exceptionAlias) return;
      throwNonBlockingError("\u0411\u043B\u043E\u043A \u0441 alias: ".concat(alias, " \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u044F \u0441\u0440\u0435\u0434\u0438 children'\u043E\u0432 SortController'\u0430"));
    }
  });
  return filtered;
};

/**
 * Вход: получаем массив, имя блока(который двигаем), позицию(на какое место двигаем)
 * Выход: массив с новым порядком позиций
 */
export var moveBlock = function moveBlock(arr, block, to) {
  var copyArr = _toConsumableArray(arr);
  var indexBlock = copyArr.findIndex(function (item) {
    return item.key === block;
  });
  copyArr.splice(to, 0, copyArr.splice(indexBlock, 1)[0]);
  return copyArr;
};